import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import alertsPlugin from './plugins/alerts'
import permissionDirective, { moduleDirective, actionDirective } from './directives/permission'
import './assets/rtl.css'
import '@fontsource/cairo/400.css'
import '@fontsource/cairo/500.css'
import '@fontsource/cairo/600.css'
import '@fontsource/cairo/700.css'

const app = createApp(App)

app.use(router)
app.use(store)
app.use(vuetify)
app.use(alertsPlugin)

// Register permission directives
app.directive('permission', permissionDirective)
app.directive('module', moduleDirective)
app.directive('action', actionDirective)

app.mount('#app')
